import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

import filter from "./filter/filterReducer";
import adminFilter from "./adminFilter/filterReducer";
import Auth from "./Auth/AuthReducer";
import Mode from "./Mode/modeReducer";

const rootReducer = combineReducers({
	Layout,
	filter,
	adminFilter,
	Auth,
	Mode,
});

export default rootReducer;
